import { render } from "./TrendingComparison.vue?vue&type=template&id=a91d5c32"
import script from "./TrendingComparison.vue?vue&type=script&lang=js"
export * from "./TrendingComparison.vue?vue&type=script&lang=js"

import "./TrendingComparison.vue?vue&type=style&index=0&id=a91d5c32&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__